export const DEFAULT_COLUMNS_OPTIONS = 4;
